<template>
  <div>
    <div class="set-groups-wrap" v-if="showComponentName">
      <span
        class="set-groups"
        @mousedown.stop
        @mouseenter.stop="mouseenterHandle"
        @mouseleave.stop="mouseleaveHandle"
        @click.stop="openLayoutComponentEdit(handle.shape, handle)"
      >
        <i class="icon" :class="handle.iconClass" v-if="handle.iconClass"></i>
        <span>{{ handle.name }}</span>
      </span>
    </div>
    <div class="set-groups-wrap" v-if="isCanDel">
      <span class="set-groups delete" v-if="isCanDel" @mousedown.stop @click.stop="del">
        <i class="icon icon-portal-delete"></i>
      </span>
    </div>
  </div>
</template>

<script>
export default {
  name: "rectHandleBtns",
  props: {
    handleList: {
      type: Array
    },
    ids: {
      type: Object
    },
    handle: {
      type: Object
    },
    isCanDel: {
      type: Boolean
    },
    index: {
      type: Number
    },
    showComponentName: {
      type: Boolean,
      default: false
    }
  },
  methods: {
    mouseenterHandle() {
      this.$emit("mouseenterHandle")
    },
    mouseleaveHandle() {
      this.$emit("mouseleaveHandle")
    },
    // 激活选中组件
    openLayoutComponentEdit() {
      this.$emit("openLayoutComponentEdit")
    },
    //删除事件触发
    del() {
      this.$emit("del")
    }
  }
}
</script>
